import { UserLight, Utilisateur } from '../../models/utilisateur';

export interface UtilisateurHttp {
  id: string;
  idOrganisme: string;
  idCognito: string;
  type: string;
  login: string;
  email: string;
  externalEmail: string;
  nom: string;
  prenom: string;
  phone: string;
  statut: string;
  codeValidation: string;
  codeValidationExpiration: string;
  gestionnaireId: string;
  dateCreation: string;
  dateModification: string;
  dateConnexion: string;
}

export interface codeValidationHttp {
  email: string;
  lastname: string;
  firstname: string;
  organization_code: string;
  type?: UserLight.Type;
  login?: string;
}

export const fromHttpToUtilisateur = (
  httpUser: UtilisateurHttp,
): Utilisateur => ({
  id: httpUser?.id,
  idCognito: httpUser?.idCognito,
  type: httpUser?.type as Utilisateur.Type,
  codeValidationExpiration: httpUser?.codeValidationExpiration,
  email: httpUser?.externalEmail || httpUser?.email || '',
  isExternalEmail: !!httpUser?.externalEmail,
  login: httpUser?.login,
  nom: httpUser?.nom || '',
  prenom: httpUser?.prenom || '',
  phone: httpUser?.phone || '',
  idOrganisme: httpUser?.idOrganisme,
  statut: httpUser?.statut,
  codeValidation: httpUser?.codeValidation,
  gestionnaireId: httpUser?.gestionnaireId,
  dateCreation: httpUser?.dateCreation,
  dateModification: httpUser?.dateModification,
  dateConnexion: httpUser?.dateConnexion,
});

export const codeValidationHttpToValidationCode = (
  httpCodeValidation: codeValidationHttp,
): UserLight => ({
  email: httpCodeValidation.email,
  lastName: httpCodeValidation.lastname,
  firstName: httpCodeValidation.firstname,
  organizationCode: httpCodeValidation.organization_code,
  type: httpCodeValidation?.type?.toUpperCase() as UserLight.Type,
  login: httpCodeValidation?.login,
});
